// Language
export const setLanguage = lang => {
  return {
    type: "SET_LANGUAGE",
    lang
  };
};
